import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    white-space: nowrap;
    height: 100%;
    background: ${displayState?.disabled ? (`${displayState?.buttonColor ?? theme?.colour?.primary ?? '#1AAA60'}4D`) : (displayState?.buttonColor ?? theme?.colour?.primary ?? '#1AAA60')};
    color: white;
    cursor: ${displayState?.disabled ? 'not-allowed' : 'pointer'};
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template });
